

export const NavActionType = {
  'SHOW_CHILD_MENU': 'show_child_menu',
  'HIDE_CHILD_MENU': 'hide_child_menu'
};

export const HeaderPanelActionType = {
  'SHOW_HEADER_PANEL': 'show_header_panel',
  'HIDE_HEADER_PANEL': 'hide_header_panel'
};

export const HeaderSearchActionType = {
  'SHOW_HEADER_SEARCH': 'show_header_search',
  'HIDE_HEADER_SEARCH': 'hide_header_search'
};

export const WindowActionType = {
  'WINDOW_LOAD': 'window_load'
};



// WEBPACK FOOTER //
// ./src/js/app/constant/actionType.js